LOCAL_PREFERENCE_COOKIE_OPTIN_ACCEPTED